import request from '@/utils/request';
// import axios from 'axios';

// const requestUser = axios.create({
//   baseURL: process.env.VUE_APP_BASE_APILogin,
//   timeout: 30000
// });
const baseUserURL = process.env.VUE_APP_USER; // /user
const baseURLAdmin = process.env.VUE_APP_ADMIN; // /admin

export function userExportAll(data) {
  return request({
    url: '/exportAll',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
}

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data,
    baseURL: baseUserURL,
    headers: { 'X-Recaptcha-V2-Token': data?.v2Token }
  });
}

export function getUserInfo() {
  return request({
    url: '/getUserInfo',
    method: 'get',
    baseURL: baseUserURL
  });
}

// 注册
export function getRegister(data) {
  return request({
    url: '/customer/register',
    method: 'post',
    data
  });
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  });
}

export function addUser(data) {
  return request({
    url: '/add',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
}

export function checkCodeUnique(data) {
  return request({
    url: '/checkCodeUnique/' + data,
    method: 'get',
    baseURL: baseUserURL
  });
}

export function roleByOrg(data) {
  return request({
    url: '/role/roleByOrg?userType=' + data,
    method: 'get',
    data,
    baseURL: baseUserURL
  });
}

export function editUser(data) {
  return request({
    url: '/edit',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
}

/**
 * 用户状态控制
 * @param data {Object} {type: '状态的类型 1:用户状态 2.账户状态',ids: '用户ID',value: '状态'}
 * @returns
 */
export function handlerUserState(data) {
  return request({
    url: '/stateHandler',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
}

/* 校验用户参数 type  检查类型 1:账户名称  2:手机号*/
export function checkUserParameter(type, value) {
  return request({
    url: '/check',
    method: 'get',
    params: { type, value },
    isLoading: false,
    baseURL: baseUserURL
  });
}

// 获取用户列表
export function getUserPage(data, isBool = true) {
  return request({
    url: '/page',
    method: 'post',
    data,
    isLoading: isBool,
    baseURL: baseUserURL
  });
}

/* 获取用户完整信息*/
export function getUserInfoById(userId) {
  return request({
    url: '/findById/' + userId,
    method: 'get',
    baseURL: baseUserURL
  });
}

// 个性化授权用户权限
export function authorizationUser(data) {
  return request({
    url: '/authorizationUser',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
}

/**
 * 获取指派人的集合
 */
export const apiGetUserList = (data, isBool = true) => {
  // return request.post('/user/user/list', data);
  return request({
    url: '/user/list',
    method: 'post',
    data,
    isLoading: isBool
  });
};
export const getContractUseType = (data, isBool = true) => {
  return request({
    url: '/user/contractUseType/getUser',
    method: 'GET',
    data,
    isLoading: isBool
  });
};

/**
 * 修改密码
 */
export const apiResetPassword = (data) => {
  return request({
    url: '/resetPassword',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
};

/**
 * 获取用户中心附件信息
 */
export const apiGetUserAdditionalInformation = (data) => {
  return request({
    url: '/getUserAdditionalInformation',
    method: 'get',
    params: { ...data },
    baseURL: baseUserURL
  });
};
/**
 * 获取用户登录工具信息
 */
export const getUserIpInformation = (data) => {
  return request({ url: '/loginLog/add', data, method: 'post', baseURL: baseUserURL });
};

/**
 * 职务分页列表
 */
export const apiGetPositionPage = (data) => {
  return request({
    url: '/position/page',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 职务列表
 */
export const apiGetPositionList = (data) => {
  return request({
    url: '/position/list',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 职务修改
 */
export const apiGetPositionEdit = (data) => {
  // eslint-disable-next-line no-undef
  return request({
    url: '/position/edit/' + data.id,
    method: 'put',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 职务添加
 */
export const apiGetPositionAdd = (data) => {
  return request({
    url: '/position/add',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 用户导出
 */
export const apiExportUser = (data) => {
  return request({
    url: '/export',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
};
// 州列表  城市列表
export const areaList = () => {
  return request({
    url: '/area/listAll',
    method: 'post',
    baseURL: baseURLAdmin
  });
};

/**
 * @description 人员登记分页
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterPage = (data) => {
  return request({
    url: '/userRegister/page',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * @description 人员登记详情
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterGetInfo = (data) => {
  return request({
    url: `/userRegister/getInfo?id=${data}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};

/**
 * @description 人员登记工作记录
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterGetWorkRecord = (data) => {
  return request({
    url: `/userRegister/getWorkRecord?id=${data}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};

/**
 * @description 人员登记评价记录
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterGetEvaluateRecord = (data) => {
  return request({
    url: `/userRegister/getEvaluateRecord?id=${data}`,
    method: 'post',
    baseURL: baseURLAdmin
  });
};

/**
 * @description 修改人员登记状态
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterUpdateStatus = (data) => {
  return request({
    url: `/userRegister/updateStatus?id=${data.ids}&state=${data.state}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};

/**
 * @description 新增人员登记评价记录
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterAddEvaluateRecord = (data) => {
  return request({
    url: `/userRegister/addEvaluateRecord`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * @description 人员登记导出
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterExportExcel = (data) => {
  return request({
    url: '/userRegister/export/excel',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * @description 人员登记导入
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterBatchAdd = (data) => {
  return request({
    url: '/userRegister/batch/add',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * @description 添加人员登记
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterAdd = (data) => {
  return request({
    url: '/userRegister/add',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * @description 修改人员登记
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const userUserRegisterEdit = (data) => {
  return request({
    url: '/userRegister/edit',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

// 获取操作人
export function getoprateUserPage(data, isBool = true) {
  return request({
    url: '/pmUser/queryPage',
    method: 'post',
    data,
    baseURL: baseUserURL,
    isLoading: isBool
  });
}

// 设置收藏夹
export const collectMenu = (data) => {
  //  return request.post('/export', data);
  return request({
    url: '/collectMenu/updateMenu',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
};
export const queryMenu = (data) => {
  //  return request.post('/export', data);
  return request({
    url: '/collectMenu/queryMenu',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
};
// 快递首页-查公告
export const getProviderNoticeMsg = (data) => {
  return request({
    url: '/message/getProviderNoticeMsg',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

// 查询cpf
export function checkCPFValidity() {
  return request({
    url: '/checkCPFValidity',
    method: 'get',
    baseURL: baseUserURL
  });
}

// 修改cpf
export function updateAccountCpf(data) {
  return request({
    url: '/updateAccountCpf',
    method: 'post',
    data,
    baseURL: baseUserURL
  });
}

// 加密解密全字段接口
export function sensitiveViewPlaintext(data) {
  return request({
    url: '/sensitive/viewPlaintext',
    method: 'post',
    data,
    baseURL: baseUserURL,
    isLoading: false
  });
}
